import React from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import TelevisionBreakpoint from "../../../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../../../components/responsive_utilities/phone_breakpoint";
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';

export class Scroller extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      speciesName: this.props.speciesName,
      boatScores: this.props.boatScores,
      boatClass: this.props.boatClass,
      classBoats: [],
      tiles: this.props.tiles
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({boatScores: newProps.boatScores, rowWidth: newProps.rowWidth, tiles: newProps.tiles, boatClass: newProps.boatClass});
      if(newProps.boatClass) {
			this.classFilter();
		} else {
			this.getBoatScores();
		}
  }
    
  classFilter() {
      var scores = this.props.boatScores;
      var boatClass = this.props.boatClass;
      var classBoats = [];
      scores.forEach((boat) => {
          if(boatClass && boat.boat.boatClass === boatClass && boat.boat.total > 0) {
              var lastF = this.getLastFishTime(boat.boat.speciesCounts);
              classBoats.push({
                  id: boat.boat.id,
                  boatClass: boat.boat.boatClass,
                  boatName: boat.boat.boatName,
									teamName: boat.boat.teamName,
                  boatThm: boat.boat.boatThm,
									speciesCounts: boat.boat.speciesCounts,
                  lastFishTime: boat.boat.lastFishTime,
                  lastSpeceiesFishTime: lastF[0],
                  total: boat.boat.total
              });
          }
      })
      this.scoreSortFilter(classBoats);
  }
	
	
	
	getBoatScores() {
      var scores = this.props.boatScores;
      var boats = [];
      scores.forEach((boat) => {
          if(boat.boat.total > 0) {
              var lastF = this.getLastFishTime(boat.boat.speciesCounts);
              boats.push({
                  id: boat.boat.id,
                  boatName: boat.boat.boatName,
									teamName: boat.boat.teamName,
                  boatThm: boat.boat.boatThm,
									speciesCounts: boat.boat.speciesCounts,
                  lastFishTime: boat.boat.lastFishTime,
                  lastSpeceiesFishTime: lastF[0],
                  total: boat.boat.total
              });
          }
      })
      this.scoreSortFilter(boats);
  }
    
  getLastFishTime(times){
      var timesArray = [];
      times.forEach((time) => {
          if(time.speciesTimes){
              time.speciesTimes.forEach((t) => {
                  var secs = new Date(t).getTime() / 1000;
                  timesArray.push(secs);
              })
          }
      })
      timesArray.sort((a, b) => b - a);
      
      return timesArray;
  }
    
  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    boatScores.sortOn("total", "lastSpeceiesFishTime");
    boatScores.reverse();
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })

    this.setState({
        classBoats: bScores
    })
  }
  
render() {
	
    if(this.state.classBoats.length < 3){
      var numSlides = this.state.classBoats.length;
    } else {
      var numSlides = 3;
    }
	
    var settings = {
      dots: false,
      arrows: false,
      infinite: true,
			autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: numSlides,
      slidesToScroll: 1,
      swipeToSlide: true,
    };
		
    const settingsPhone = {
			customPaging: function(i) {
        return (
          <a>
            {i + 1}
          </a>
        );
      },
      dots: true,
			dotsClass: "slick-dots slick-thumb",
      arrows: false,
      infinite: true,
			autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 5,
      slidesToScroll: 5,
      swipeToSlide: true,
			vertical: true,
    };
    return (
      <div className="speciesScoresBoxPelagicQueposDesk"> 
				<TelevisionBreakpoint>
					<div className="scores"> 
						<Slider {...settings}>
							{this.state.classBoats.map(boat => (
								<div id='rank-box' className="boatBox" style={{width: '100%', margin: 10, padding: 5}} key={boat.boat.id}>
									{boat.boat.boatThm ? 
										<div id='boat-total' 
											style={{
												position: 'relative',
												backgroundSize: 'cover',
												backgroundRepeat: 'no-repeat',
												backgroundPosition: '50% 100%',
												borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
												borderSize: 4,
												borderStyle: 'solid',
												width: '100%', 
												height: boat.rank === 1 ? 180 : 155, 
												backgroundImage: 'url(' + boat.boat.boatThm + ')'
											}}>
												<div id='boat-rank' style={{height: 30, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 24, backgroundColor: '#ccc', color: '#191970', opacity: 0.7, overflow: 'hidden', textOverflow:'clip'}}>
													<center>{boat.boat.teamName || boat.boat.boatName} </center>
												</div>
												<div id='rank'
													style={{
														backgroundColor: 'white',
														width: 60,
														height: 60,
														borderRadius: 30,
														float: 'left',
														marginTop: -5,
														marginLeft: 5,
														fontWeight: 'bold', 
														fontSize: 30,
														opacity: .7,
													}}> 
												 <center style={{lineHeight: 1.8}}># {boat.rank}</center>
												</div>
												<div id='boat-total' style={{height: 40, float: 'right', fontWeight: 'bold', fontSize: 26, backgroundColor: '#fff', opacity: .7, color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute',
														bottom: 0, right: 0}}>
													<center>Pts: {boat.boat.total}</center>
												</div>
											</div> :
										<div id='boat-total' 
											style={{
												position: 'relative',
												backgroundSize: 'cover',
												backgroundRepeat: 'no-repeat',
												backgroundPosition: '50% 50%',
												borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
												borderSize: 4,
												borderStyle: 'solid',
												width: '100%', 
												height: boat.rank === 1 ? 180 : 155, 
												backgroundImage: 'url(' + defaultImage + ')'
											}}>
												<div id='boat-rank' style={{height: 30, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 24, backgroundColor: '#ccc', color: '#191970', opacity: 0.7, overflow: 'hidden', textOverflow:'clip'}}>
													<center>{boat.boat.teamName || boat.boat.boatName} </center>
												</div>
												<div id='rank'
													style={{
														backgroundColor: 'white',
														width: 60,
														height: 60,
														borderRadius: 30,
														float: 'left',
														marginTop: -5,
														marginLeft: 5,
														fontWeight: 'bold', 
														fontSize: 30,
														opacity: .7,
													}}> 
												 <center style={{lineHeight: 1.8}}># {boat.rank}</center>
												</div>
												<div id='boat-total' style={{height: 40, float: 'right', fontWeight: 'bold', fontSize: 26, backgroundColor: '#fff', opacity: .7, color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute',
														bottom: 0, right: 0}}>
													<center>Pts: {boat.boat.total}</center>
												</div>
											</div>
					}
								</div>
							))}
						</Slider> 
						<div className="class_title_tv">{ this.state.boatClass } Billfish Division</div>
					</div>
				</TelevisionBreakpoint>
				<DesktopBreakpoint>
					<div className="speciesScoresBoxPelagicQueposDesk"> 
					<div className="division_title">{this.props.boatClass} Billfish Division</div>
					{this.state.classBoats.length > 0 ? <Slider {...settings}>
						{this.state.classBoats.map(boat => (
							<div id='rank-box' className="boatBox" style={{width: '100%', margin: 10, padding: 5}} key={boat.boat.id}>
								{boat.boat.boatThm ? 
									<div id='boat-total' 
										style={{
											position: 'relative',
											backgroundSize: 'cover',
											backgroundRepeat: 'no-repeat',
											backgroundPosition: '50% 50%',
											borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
											borderSize: 4,
											borderStyle: 'solid',
											width: '100%', 
											height: boat.rank === 1 ? 130 : 110, 
											backgroundImage: 'url(' + boat.boat.boatThm + ')'
										}}>
											<div id='boat-rank' style={{height: 25, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 16, backgroundColor: '#ccc', color: '#191970', overflow: 'hidden', textOverflow:'clip'}}>
												<center>{boat.boat.teamName || boat.boat.boatName} </center>
											</div>
											<div id='rank'
												style={{
													backgroundColor: 'white',
													width: 40,
													height: 40,
													borderRadius: 20,
													float: 'left',
													marginTop: -15,
													marginRight: 5,
													fontWeight: 'bold', 
													fontSize: 20,
													opacity: .7,
												}}> 
											 <center style={{lineHeight: 1.8}}> # {boat.rank}</center>
											</div>
											<div id='boat-total' style={{height: 25, width: '100%', float: 'right', fontWeight: 'bold', fontSize: 16, backgroundColor: '#fff', color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute', bottom: 0, right: 0, opacity: .6}}>
												<center>{boat.boat.total} pts</center>
											</div>
										</div> :
									<div id='boat-total' 
										style={{
											position: 'relative',
											backgroundSize: 'cover',
											backgroundRepeat: 'no-repeat',
											backgroundColor: '#ccc',
											backgroundPosition: '50% 50%',
											borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
											borderSize: 4,
											borderStyle: 'solid',
											width: '100%', 
											height: boat.rank === 1 ? 130 : 110, 
											backgroundImage: 'url(' + defaultImage + ')'
										}}>
											<div id='boat-rank' style={{height: 25, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 18, backgroundColor: '#ccc', color: '#191970', overflow: 'hidden', textOverflow:'clip'}}>
												<center>{boat.boat.teamName || boat.boat.boatName} </center>
											</div>
											<div id='rank'
												style={{
													backgroundColor: 'white',
													width: 40,
													height: 40,
													borderRadius: 20,
													float: 'left',
													marginTop: -15,
													marginRight: 5,
													fontWeight: 'bold', 
													fontSize: 20,
													opacity: .7,
												}}> 
											 <center style={{lineHeight: 1.8}}> # {boat.rank}</center>
											</div>
											<div id='boat-total' style={{height: 25, width: '100%', float: 'right', fontWeight: 'bold', fontSize: 18, backgroundColor: '#fff', color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute', bottom: 0, right: 0, opacity: .6}}>
												<center>{boat.boat.total} pts</center>
											</div>
										</div>
								}
							</div>
						))}
					</Slider> : <div style={{color: '#fff', fontSize: 24}}>No fish logged yet.</div> 
				}
				</div>
				</DesktopBreakpoint>
				<TabletBreakpoint>
					<div className="smv-scoreContainer"> 
						<div className="score_box_title">Billfish</div>
							{this.state.classBoats.length > 0 ? <Slider {...settings}>
								{this.state.classBoats.map(boat => (
									<div className="smv-boatBox" key={boat.boat.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {boat.rank} {boat.boat.boatName}
													</div>
													<div id='rank' className="smv-rankBox2">
						Team: {boat.boat.teamName != boat.boat.boatName ? boat.boat.teamName: 'NA'}</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{boat.boat.total} pts
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
					</div>
				</TabletBreakpoint>
				<PhoneBreakpoint>
					<div className="smv-scoreContainer"> 
						<div className="score_box_title">Billfish</div>
							{this.state.classBoats.length > 0 ? <Slider {...settingsPhone}>
								{this.state.classBoats.map(boat => (
									<div className="smv-boatBox" key={boat.boat.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {boat.rank} {boat.boat.boatName}
													</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{boat.boat.speciesCounts.map(specie => (
														<div className="speciesNumsRow">
															<div className="speciesNumsBox">
																<div className="speciesNums2">
																	 {specie.speciesCount ?specie.speciesCount: null}
																 </div> 
																<div className="speciesNumsTitle">
																	{specie.speciesCount ? specie.speciesName: null}
																</div>
															</div>
														</div>
													))}
													<div className="boatPoints">
														{boat.boat.total} pts
													</div>
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
					</div>
				</PhoneBreakpoint>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/qbc/comps/Scroller.js